import { useState, useEffect, useRef } from 'react';
import './VideoModal.css';

export default function VideoModal() {
  const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Abre el modal automáticamente al cargar el componente
    setIsOpen(true);
  }, []);

  const closeModal = () => {
    if (videoRef.current) {
      videoRef.current.pause(); // Pausa el video al cerrar
    }
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="videoModalOverlay">
      <div className="videoModalBox">

        {/* Botón de cerrar */}
        <button
          onClick={closeModal}
          className="videoModalCloseBtn"
        >
          ✕
        </button>

        {/* Reproductor de Video */}
        <div className="videoModalPlayerWrapper">
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
          >
            <source src="/videos/intro.mp4" type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>

      </div>
    </div>
  );
}
